import { createContext } from "react";

export const JsonDataContextEvent = createContext(null);